<template>
  <page>
    <div slot="head" class="page-head-default" style="justify-content: flex-end;">
      <img src="../../assets/imgs/back.png" alt="" @click="goRouter('/')">
      <div style="padding: 20px;" @click="goRouter('/order')">{{$t('order.title')}}</div>
    </div>
    <!-- {{args}}
    <div>{{pay_info}}</div> -->
    <!-- <div class="wallet-balance-main-title">{{i18n.wallet}}</div>
    <div class="wallet-balance-main">
      <div class="wallet-balance-main-warp">
        <div class="title">{{i18n.prestore}}</div>
        <div class="tips">{{i18n.prestore_tips}}</div>
        <div class="line"></div>
        <div>{{user && user.pcurrency}} {{user && user.pbalance || 0}}</div>
        <div>{{i18n.balance}}</div>
      </div>
      <div class="wallet-main-btn" @click="goRouter('/wallet_in?qrcode='+qrcode)">{{i18n.wallet_in}}</div>
    </div>
    <div class="wallet-balance-main">
      <div class="wallet-balance-main-warp">
        <div class="title">{{i18n.single}}</div>
        <div class="tips">{{i18n.single_tips}}</div>
        <div class="line"></div>
        <div v-if="user && user.pyajinBalance || (user && Number(user.pyajin))">{{i18n.paid}}</div>
        <div class="gray" v-else>{{i18n.unpaid}}</div>
        <div>{{i18n.deposit}}</div>
      </div>
      <div class="wallet-main-btn" v-if="user && user.pyajinBalance" @click="onTixian">{{i18n.wallet_out}}</div>
      <div class="wallet-main-btn" @click="onSubmit">{{i18n.deposit_btn}}</div>
    </div>
    <div class="wallet-balance-main-tips">{{i18n.wallet_tips}}</div> -->
    <div class="wallet-balance-main-title">
      <span>{{i18n.wallet}}</span>
    </div>
    <div class="wallet-balance-main">
      <img class="wallet-balance-main-bg" src="../../assets/imgs/vip_bg.png" />
      <div class="wallet-balance-main-warp">
      <div class="title">{{i18n.prestore}}</div>
      <div>{{i18n.prestore_tips}}</div>
      <div>{{i18n.prestore_tips2}}</div>
      <div class="line"></div>
      <template v-if="user && vipTypes.includes(user.vip_name)">
        <div class="title">{{i18n.prestore_type}}</div>
        <div>{{i18n.prestore_date}}: {{user.vip_date | dateFmt('DD/MM/YYYY')}}</div>
      </template>
      <div class="tips" v-else>{{i18n.prestore_type2}}</div>
      </div>
      <!-- <div v-if="user && !vipTypes.includes(user.vip_name)" :class="{ 'wallet-main-btn': 0>1, 'disabled': 1>0 }" @click="goRouter('/wallet_in?qrcode='+qrcode)">{{i18n.wallet_in}}</div> -->
      <div v-if="user && !vipTypes.includes(user.vip_name)" class="disabled">{{i18n.nouse}}</div>
    </div>
    <!-- <div class="wallet-balance-main">
      <div class="wallet-balance-main-warp">
        <div class="title">{{i18n.single}}</div>
        <div v-if="!isH5DoMain">{{i18n.single_tips}}</div>
        <div v-else>{{i18n.single_tips1}}</div>
        <div v-if="!isH5DoMain">{{i18n.single_tips2}}</div>
        <div class="line"></div>
        <span>{{i18n.deposit}}</span>
        <template  v-if="user && user.pyajinBalance">
          <span class="title">{{i18n.paid}}</span>
          <span> {{amount > 0 ? `HK$${user.pyajinBalance}` : ''}}</span>
        </template>
        <span class="title" v-else-if="user && Number(user.pyajin)">{{i18n.using}}</span>
        <span class="tips" v-else>{{i18n.unpaid}}</span>
      </div>
      <div>
        <div class="wallet-main-btn wallet-main-btn2" v-if="user && user.pyajinBalance" @click="onTixian">{{i18n.wallet_out}}</div>
        <div class="wallet-main-btn" v-if="amount > 0" @click="onPay">{{i18n.deposit_btn}}</div>
      </div>
    </div> -->
    <div class="wallet-balance-main">
      <div class="wallet-balance-main-warp">
        <div class="title">{{i18n.single}}</div>
        <div v-if="!isH5DoMain">{{i18n.single_tips}}</div>
        <div v-else>{{i18n.single_tips1}}</div>
        <div v-if="!isH5DoMain">{{i18n.single_tips2}}</div>
        <div class="line"></div>
        <span>{{i18n.balance}}</span>
        <span class="tips">HK${{user.p_balance || 0}}</span>
        <!-- <template  v-if="user && user.p_balance">
          <span class="title">{{i18n.paid}}</span>
          <span> {{amount > 0 ? `HK$${user.p_balance}` : ''}}</span>
        </template>
        <span class="title" v-else-if="user && Number(user.pyajin)">{{i18n.using}}</span>
        <span class="tips" v-else>{{i18n.unpaid}}</span> -->
      </div>
      <div>
        <!-- <div class="wallet-main-btn wallet-main-btn2" v-if="user && user.p_balance" @click="onTixian">{{i18n.wallet_out}}</div> -->
        <!-- <div class="wallet-main-btn" v-else @click="onSubmit">{{i18n.deposit_btn}}</div> -->
        <!-- <div class="wallet-main-btn" v-else-if="browser === 'mpay'" @click="onSubmit">{{i18n.deposit_btn}}</div> -->
        <div class="wallet-main-btn" v-if="qrcode && amount > 0" @click="onPay(false)">{{i18n.deposit_btn}}</div>
        <template v-else>
          <div class="wallet-main-btn" @click="onPay(true)">{{i18n.wallet_in}}</div>
          <div :class="user && user.p_balance ? 'wallet-main-btn wallet-main-btn2' : 'disabled'" @click="onTixian">{{i18n.wallet_out}}</div>
        </template>
      </div>
    </div>
    <paytype v-if="payTypeShow" ref="paytype" :payTitle="payTitle" :paySubTitle="paySubTitle" :pPrice="rechargeAmount" :payTypeShow="payTypeShow" :isAdd="isAdd" @back="onBack" @changeRadio="changeRadio" @goPay="goPay" />
    <div>{{test}}</div>
    <div class="wallet-tips">{{i18n.wallet_tips}}</div>
    <div class="wallet-tips">{{i18n.wallet_tips2}}</div>
    <div class="wallet-tips">{{i18n.wallet_tips3}}</div>
  </page>
</template>

<script>
import { USER_INFO } from '../../apis/user.js'
import { YEDPAY_RECHARGE, EFT_RECHARGE, MPAY_RECHARGE, PAYPAL_RECHARGE, WX_PAY_RECHARGE, WEPAYEZ_PAYCONFIRM } from '../../apis/payment.js'
import { mapState } from 'vuex'
import { baseURL } from '../../utils/http'
export default {
  computed: {
    ...mapState(['user', 'browser', 'area', 'cabinet']),
    i18n () {
      return this.$t('mine')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nConfirm () {
      return this.$t('confirm')
    },
    isH5DoMain () {
      return baseURL.indexOf('h5.easycharge') !== -1
    }
  },
  data () {
    return {
      qrcode: '',
      args: '',
      pay_info: '',
      test: '',
      payTypeShow: false,
      payTypeValue: 'AlipayCN',
      amount: process.env.VUE_APP_YAJIN,
      pay: process.env.VUE_APP_PAY === '1',
      vipTypes: ['VIP会员', '双月通会员', '全年通贵宾', '季度通会员'],
      isAdd: false,
      rechargeAmount: 0,
      payTitle: '',
      paySubTitle: ''
    }
  },
  methods: {
    onBack (v) {
      this.payTypeShow = v
    },
    changeRadio (v) {
      console.log('radio', v.index, v.value)
      this.payTypeValue = v.value
    },
    onPay (val) {
      if (val) {
        this.payTitle = this.$t('wallet_in.title')
        this.paySubTitle = this.$t('wallet_in.price_label')
        this.rechargeAmount = '198'
      } else {
        this.payTitle = this.i18nMsg.payYaJinTitle
        this.paySubTitle = this.i18nMsg.payYaJinSubTitle
        this.rechargeAmount = this.amount
      }
      this.isAdd = val
      this.payTypeShow = true
    },
    goPay (v, amount) {
      this.payTypeValue = v
      this.amount = amount
      this.onSubmit()
    },
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit('user', resp.user)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              // confirmspan: this.i18nMsg.retry,
              showOk: false,
              cancelspan: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            // confirmspan: this.i18nMsg.retry,
            showOk: false,
            cancelspan: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    goRouter (path) {
      this.$router.push(path)
    },
    onSubmit () {
      if (this.browser === 'mpay') {
        this.mpayPrepay()
        return
      } else if (this.payTypeValue === 'Paypal') {
        this.onPaypal()
        return
      } else if (this.payTypeValue === 'WeChat') {
        this.onWechat()
        return
      }
      this.$loading(true)
      this.$post(
        this.pay ? EFT_RECHARGE : `${YEDPAY_RECHARGE}${this.qrcode ? '?qrcode=' + this.qrcode + '&' : '?'}amount=${this.amount}`,
        {
          qrcode: this.qrcode,
          amount: this.amount,
          apiType: 'H5',
          payChannel: this.payTypeValue,
          returnUrl: `${window.location.protocol}//${window.location.host}${window.location.pathname}#/result`
        },
        res => {
          this.$loading(false)
          console.log(res, window.location.href)
          if (res.data && res.data.pay_apptrade) {
            window.location.href = res.data.pay_apptrade
            // window.open(res.data.pay_apptrade)
            setTimeout(() => {
              this.$confirm({
                title: this.i18nConfirm.msg_fail_title,
                content: this.i18nConfirm.title,
                confirmText: this.i18nConfirm.msg_fail_payconfirm,
                cancelText: this.i18nConfirm.msg_fail_cancel
              }).then(() => {
                this.$router.push(`/result?outTradeNo=${res.data.out_trade_no}`)
              })
            }, 3000)
          } else {
            this.$toast(res.msg)
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    onTixian () {
      if (this.user && this.user.p_balance) {
        this.$router.push('wallet_out')
      }
    },
    mpayPrepay () {
      // let vm = this
      this.$loading(true)
      this.$post(
        `${MPAY_RECHARGE}?qrcode=${this.qrcode}&amount=${this.amount}&apiType=QRCODE&payChannel=mpay`,
        {},
        res => {
          this.$loading(false)
          // if (window.mp) {
          //   window.mp.choosePayMent({
          //     paymentData: JSON.parse(res.data.data.pay_info),
          //     success: function (res) { // 支付成功回調 以下是 res 示例
          //       console.log('支付成功----', res)
          //       // vm.$emit('loadlist')
          //       vm.loadUser()
          //       // window.location.reload()
          //     },
          //     fail: function (error) {
          //       console.log('mpay支付失败---', error)
          //       vm.$toast(error)
          //     }, // 支付失敗回調
          //     cancel: function (res) { // 以下是 res 內容示例
          //       console.log('mpay取消支付---', res)
          //     } // 取消支付回調
          //   })
          // } else {
          //   this.loadMpayScript(this.mpayPrepay)
          // }
          if (res.data && res.data.qr_code) {
            window.location.href = res.data.qr_code
          } else {
            this.$toast(res.msg)
          }
        },
        error => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onPaypal () {
      this.$loading(true)
      let url = ''
      if (this.qrcode) {
        url = `${PAYPAL_RECHARGE}/${this.qrcode}`
      } else {
        url = PAYPAL_RECHARGE
      }
      this.$post(
        url,
        {
          amount: this.amount
        },
        resp => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(true)
            window.location.href = resp.data.checkOutUrl
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: this.i18nConfirm.msg_fail_order,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        }
      )
    },
    onWechat () {
      this.$loading(true)
      this.$post(
        WX_PAY_RECHARGE,
        {
          amount: this.amount,
          // amount: '0.01',
          qrcode: this.qrcode,
          // returnUrl: window.location.href
          returnUrl: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/result'
          // returnUrl: 'https://app.easycharge.com.hk'
        },
        resp => {
          this.$loading(false)
          if (resp.data && resp.data.payInfo) {
            window.location.href = resp.data.payInfo
          } else {
            this.$toast(resp.msg)
          }
        },
        error => {
          this.$loading(false)
          this.$toast(error)
          console.log(error)
        }
      )
    },
    onWechatConfirm (param) {
      this.$loading(true)
      let url = WEPAYEZ_PAYCONFIRM
      this.$post(
        url,
        {
          outTradeNo: param.out_trade_no
        },
        resp => {
          this.$loading(false)
          if (resp.data) {
            if (this.qrcode) {
              this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
            } else {
              this.payTypeShow = false
              this.loadUser()
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: error,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.onWechatConfirm()
          })
          console.log(error)
        }
      )
    }
  },
  created () {
    this.$loading(false)
    this.loadUser()
    this.qrcode = this.$route.query.qrcode || ''
    this.amount = process.env.VUE_APP_YAJIN - this.user.p_balance
  }
}
</script>

<style lang="less">
.disabled{
  font-size: 32px;
  color: #FFFFFF;
  padding: 20px 36px;
  background-color: #a1a1a1;
  border-radius: 10px;
  box-shadow:2px 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 999;
  margin: 20px 0;
}
// .wallet-balance-main-title {
//   padding: 30px 0 0 56px;
//   font-size: 48px;
//   color: #666666;
// }
// .wallet-balance-main{
//   margin: 20px 36px;
//   padding: 60px 20px 60px 40px;
//   background: linear-gradient(90deg, #36b8e5 0, #39b8e5 100%);
//   border-radius: 20px;
//   color: #ffffff;
//   display: flex;
//   align-items: center;
//   &-warp{
//     flex: 1;
//     font-size: 28px;
//     .title {
//       font-size: 48px;
//     }
//     .tips {
//       font-size: 24px;
//       color: #b3d5e1;
//     }
//     .line {
//       height: 1Px;
//       width: 200px;
//       margin: 16px 0;
//       background-color: #fff;
//     }
//   }
// }
// .wallet-main-btn{
//   padding: 20px 36px;
//   background-color: #87d008;
//   border-radius: 20px;
//   box-shadow:2px 2px 5px #333333;
// }
// .wallet-balance-main-tips {
//   color: #F56C6C;
//   padding: 0 40px;
// }

.wallet-balance-main-title {
  padding: 30px 56px 0 56px;
  font-size: 48px;
  color: #666666;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.wallet-balance-main-log {
  font-size: 36px;
  color: #05A6DD;
}
.wallet-balance-main{
  margin: 20px 36px;
  padding: 40px 20px 40px 40px;
  background-color: #FFFFFF;
  border-radius: 20px;
  font-size: 24px;
  color: #6f6f6f;
  display: flex;
  align-items: center;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  &-bg {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 400px;
  height: 200px;
  }
  &-warp{
    flex: 1;
    font-size: 26px;
    .title {
      font-size: 48px;
    color: #000;
    }
    .tips {
      font-size: 48px;
    color: #4aa3d7;
    }
    .line {
      height: 1Px;
      width: 200px;
      margin: 16px 0;
      background-color: #000;
    }
  }
}
.wallet-main-btn{
  font-size: 32px;
  color: #FFFFFF;
  padding: 20px 36px;
  background-color: #05a6dc;
  border-radius: 10px;
  box-shadow:2px 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 999;
  margin: 20px 0;
  text-align: center;
}
.wallet-main-btn2 {
  background-color: #c86b63;
}
.wallet-tips {
  padding: 20px;
  font-size: 28px;
  color: #666666;
}
</style>
